<template>
  <b-card class="custom-label-group-wrapper">
    <b-form-group class="custom-label-group" :label="label" :label-for="labelFor" v-slot="{ ariaDescribedby }">
      <b-form-radio-group
        stacked
        :disabled="disabled"
        :id="labelFor"
        :options="options"
        :aria-describedby="ariaDescribedby"
        :checked="value"
        @input="$emit('input', $event)"
      ></b-form-radio-group>
    </b-form-group>
  </b-card>
</template>

<script>
export default {
  props: ['label', 'labelFor', 'options', 'value', 'disabled'],
};
</script>

<style>
.custom-label-group-wrapper > .card-body {
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}
.custom-label-group > label {
  margin-bottom: 0.2rem;
  font-size: 12px;
  color: #777;
}
.custom-label-group .custom-control > .custom-control-input {
  margin-right: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/organisation/BCustomSelect.vue